// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

.stage-footer_stage-footer-wrapper_U1l1E {
    display: flex;
    margin: auto;
    justify-content: space-between;
    align-items: center;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.stage-footer_stage-footer-wrapper_U1l1E * {
    box-sizing: border-box;
}

.stage-footer_fire-button_RM3rP {
    border: 1px solid var(--ui-black-transparent);
    border-radius: calc(0.5rem / 2);
    background: var(--ui-white);
    padding: 0.375rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    cursor: pointer;
}

.stage-footer_fire-button_RM3rP:active {
    background-color: var(--looks-transparent);
}

.stage-footer_fire-reaction-icon_Oym9w {
    height: 2rem;
}

.stage-footer_fire-reaction-off-icon__XEFu {
    filter: var(--filter-icon-gray);
}

.stage-footer_views-count_BFIKc {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.stage-footer_views-icon_R39IZ {
    height: 2rem;
}

.stage-footer_forks-button_suMcY {
    border: 1px solid var(--ui-black-transparent);
    border-radius: calc(0.5rem / 2);
    background: var(--ui-white);
    padding: 0.375rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    cursor: pointer;
}

.stage-footer_forks-button_suMcY:active {
    background-color: var(--looks-transparent);
}

.stage-footer_fork-icon_PFuy0 {
    height: 1.75rem;
}

.stage-footer_footer-buttons-row_vYXQl {
    display: flex;
    gap: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/dash-stage-footer/stage-footer.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;IACI,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,6CAA6C;IAC7C,+BAA+B;IAC/B,2BAA2B;IAC3B,iBAAiB;IACjB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,eAAe;AACnB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6CAA6C;IAC7C,+BAA+B;IAC/B,2BAA2B;IAC3B,iBAAiB;IACjB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,eAAe;AACnB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;AACf","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n.stage-footer-wrapper {\n    display: flex;\n    margin: auto;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n}\n\n.stage-footer-wrapper * {\n    box-sizing: border-box;\n}\n\n.fire-button {\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: calc(0.5rem / 2);\n    background: var(--ui-white);\n    padding: 0.375rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: pointer;\n}\n\n.fire-button:active {\n    background-color: var(--looks-transparent);\n}\n\n.fire-reaction-icon {\n    height: 2rem;\n}\n\n.fire-reaction-off-icon {\n    filter: var(--filter-icon-gray);\n}\n\n.views-count {\n    display: flex;\n    align-items: center;\n    gap: 0.375rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.views-icon {\n    height: 2rem;\n}\n\n.forks-button {\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: calc(0.5rem / 2);\n    background: var(--ui-white);\n    padding: 0.375rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: pointer;\n}\n\n.forks-button:active {\n    background-color: var(--looks-transparent);\n}\n\n.fork-icon {\n    height: 1.75rem;\n}\n\n.footer-buttons-row {\n    display: flex;\n    gap: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `stage-footer_stage-footer-wrapper_U1l1E`;
export { _1 as "stage-footer-wrapper" };
export var stageFooterWrapper = `stage-footer_stage-footer-wrapper_U1l1E`;
var _2 = `stage-footer_fire-button_RM3rP`;
export { _2 as "fire-button" };
export var fireButton = `stage-footer_fire-button_RM3rP`;
var _3 = `stage-footer_fire-reaction-icon_Oym9w`;
export { _3 as "fire-reaction-icon" };
export var fireReactionIcon = `stage-footer_fire-reaction-icon_Oym9w`;
var _4 = `stage-footer_fire-reaction-off-icon__XEFu`;
export { _4 as "fire-reaction-off-icon" };
export var fireReactionOffIcon = `stage-footer_fire-reaction-off-icon__XEFu`;
var _5 = `stage-footer_views-count_BFIKc`;
export { _5 as "views-count" };
export var viewsCount = `stage-footer_views-count_BFIKc`;
var _6 = `stage-footer_views-icon_R39IZ`;
export { _6 as "views-icon" };
export var viewsIcon = `stage-footer_views-icon_R39IZ`;
var _7 = `stage-footer_forks-button_suMcY`;
export { _7 as "forks-button" };
export var forksButton = `stage-footer_forks-button_suMcY`;
var _8 = `stage-footer_fork-icon_PFuy0`;
export { _8 as "fork-icon" };
export var forkIcon = `stage-footer_fork-icon_PFuy0`;
var _9 = `stage-footer_footer-buttons-row_vYXQl`;
export { _9 as "footer-buttons-row" };
export var footerButtonsRow = `stage-footer_footer-buttons-row_vYXQl`;
export default ___CSS_LOADER_EXPORT___;
